import Carousel from 'react-bootstrap/Carousel';
import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";

import AnimatedText from '../components/animatedtext';

import '../css/topproducts.css';

function useBreakpoint() {
  const getBreakpoint = () => {
    if (window.matchMedia("(max-width: 575px)").matches) return "mobile";
    if (window.matchMedia("(max-width: 991px)").matches) return "tablet";
    return "desktop";
  };

  const [breakpoint, setBreakpoint] = useState(getBreakpoint);

  useEffect(() => {
    const handler = () => setBreakpoint(getBreakpoint());
    window.addEventListener("resize", handler);
    return () => window.removeEventListener("resize", handler);
  }, []);

  return breakpoint;
}

function chunkArray(arr, size) {
  const result = [];
  for (let i = 0; i < arr.length; i += size) {
    result.push(arr.slice(i, i + size));
  }
  return result;
}

export default function TopProducts() {

    const breakpoint = useBreakpoint();
    const perSlide = { mobile: 2, tablet: 3, desktop: 4 }[breakpoint];
    const [index, setIndex] = useState(0);
    const params = useParams();

    const [ITEMS, setITEMS] = useState([]);

    useEffect(() => {

        fetch(`https://api.negativbrand.com/${params.lang}/api/topproducts/12`)
            .then(response => response.json())
            .then(data => {
                setITEMS(data);
            })
            .catch(error => {
                console.error(error);
            });

    }, [params.lang]);

    const slides = chunkArray(ITEMS, perSlide);
/* 
            karta z opisem
                    <img
                    src={item.image}
                    alt={item.title}
                    className="card-img-top"
                    style={{ aspectRatio: "4/3", objectFit: "cover" }}
                    />
                    <div className="card-body px-0 pt-2 pb-0">
                        <p className="card-title mb-0 fw-medium">{item.title}</p>
                        <p className="card-text text-muted small">{item.sub}</p>
                    </div>

                    albo  sam obrazek

                    <img
                        src={item.image}
                        alt={item.title}
                        className="rounded-2"
                        style={{ width: "100%", aspectRatio: "4/3", objectFit: "cover", display: "block" }}
                        />

                        fotki od dechy do dechy
                        <div className="d-flex">

                        fotki z przerwami
                        <div className="d-flex gap-3 px-5">
*/
    return (
        <>
        
        <Carousel interval={7000} indicators={false} controls={true} activeIndex={index} onSelect={setIndex}>
        
            {slides.map((group, slideIndex) => (
                <Carousel.Item key={slideIndex}>

                    <div className="d-flex gap-1 px-2">
                        {group.map((item) => (
                        <div
                            key={item.id}
                            className="card top-products-card border-1 h-100"
                            style={{ minWidth: 0, "--bs-card-bg": "#090909", borderRadius: 2, "--bs-card-border-color": "#111", color: "#FFF" }}
                        >

                            <a href={item.link}>
                                <img
                            src={item.image}
                            alt={item.name}
                            className="card-img-top"
                            />
                            </a>
                            
                            <div className="card-body card-body-top-products">
                                <div className="card-category">
                                    {item.category} <span>NEGATIV</span> <div className="card-product-name">{item.name}</div>
                                </div>
                            </div>
                            
                        </div>
                        ))}
                    </div>
                    
                </Carousel.Item>
            ))}

        </Carousel>

        <div className="d-flex justify-content-center gap-2 mt-3">
            {slides.map((_, i) => (
            <button
                className="carousel-buttons"
                key={i}
                onClick={() => setIndex(i)}
                style={{
                width: i === index ? "5rem" : "1.5rem",
                height: "0.25rem",
                borderRadius: "1rem",
                border: i === index ? "1px solid #8b6736" : "1px solid #333",
                background: "#222",
                padding: 0,
                transition: "all 1s ease",
                }}
                aria-label={`Slajd ${i + 1}`}
            />
            ))}
        </div>

        <div style={{padding: "40px 40px 10px 40px"}}>
            <AnimatedText text="<s>#NGV</s> That's what she said! <s>It's outstanding!</s>" effect="typing" speed={40} startOnView={true} cursor={true} />
        </div>

        </>
    )
}